import React from 'react'
import { SegmentedControl } from '../../../components/SegmentedControl/SegmentedControl'

export type WorkflowTab = 'needs-action' | 'running' | 'completed' | 'library'

export interface WorkflowTabCounts {
  'needs-action': number | null
  running: number | null
  completed: number | null
}

interface WorkflowsTabBarProps {
  activeTab: WorkflowTab
  counts: WorkflowTabCounts
  onSelect: (tab: WorkflowTab) => void
}

export const WorkflowsTabBar: React.FC<WorkflowsTabBarProps> = ({ activeTab, counts, onSelect }) => {
  const runOptions = [
    { key: 'needs-action', label: 'Needs action', count: counts['needs-action'] },
    { key: 'running', label: 'Running', count: counts.running },
    { key: 'completed', label: 'Completed', count: counts.completed },
  ]

  return (
    <div className='d-flex gap-2 align-items-center flex-wrap'>
      <SegmentedControl
        options={runOptions}
        activeKey={activeTab}
        ariaLabel='Workflow run views'
        surface='gray'
        onSelect={(key) => onSelect(key as WorkflowTab)}
      />
      <SegmentedControl
        options={[{ key: 'library', label: 'Library', hideCount: true }]}
        activeKey={activeTab}
        ariaLabel='Workflow library'
        surface='gray'
        onSelect={(key) => onSelect(key as WorkflowTab)}
      />
    </div>
  )
}

export default WorkflowsTabBar
